// extracted by mini-css-extract-plugin
export default {"fs":"_555f54b198 _8b42e17989"};